import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { getFeeds } from "../../../../Redux/Reducers/communityReducer";
import FeedPostSkeleton from "../../../LoadingSkeleton/Events/FeedPostSkeleton";
import FeedCard from "./FeedCard";
import usePagination from "./usePagination";
import FeedIcon from "../../../..//Assets/css/Community/FeedIcon.webp";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const FeedScreen = () => {
  const location = useLocation();
  const scrollToFeedId = location.state?.scrollToFeedId;
  const feedRefs = useRef({});
  const loaderRef = useRef();
  const exploreType = useSelector((state) => state?.community?.exploreType);

  const {
    data: feedsData,
    loading: loadingFeeds,
    hasMore,
    handleLoadMore,
    handleRefresh,
  } = usePagination((state) => state?.community?.feeds, getFeeds, {
    type: exploreType,
  });

  // console.log("feedsData", feedsData)

  

  //   const orderedFeeds = scrollToFeedId
  // ? [
  //     ...feedsData.filter((item) => item.id === Number(scrollToFeedId)),
  //     ...feedsData.filter((item) => item.id !== Number(scrollToFeedId)),
  //   ]
  // : feedsData;

useEffect(() => {
  if (scrollToFeedId && feedRefs.current[scrollToFeedId]) {
    feedRefs.current[scrollToFeedId].scrollIntoView({ block: "center"}); // or add behavior: "auto"
  }
}, [feedsData]);

  useEffect(() => {
    if (feedsData?.length === 0 && !loadingFeeds) {
      handleRefresh();
    }
  }, [feedsData?.length, loadingFeeds, handleRefresh]);

  useEffect(() => {
    if (!loaderRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !loadingFeeds) {
          handleLoadMore();
        }
      },
      { rootMargin: "200px" }
    );
    observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [hasMore, loadingFeeds, handleLoadMore]);

  const showNoPosts = !loadingFeeds && feedsData?.length === 0;

  return (
    <>
      {showNoPosts ? (
        <Box sx={{ textAlign: "center",height: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          <img
            src={FeedIcon} // You can use a placeholder image or custom illustration
            alt="No Posts Found"
            style={{ width: 80, marginBottom: 16 , opacity: 0.8 }}
          />
          <Typography variant="h6" sx={{fontSize:"14px"}}>
            No Posts Found
          </Typography>
        </Box>
      ) : (
        <>
          <Grid container spacing={1}>
            {feedsData?.map((item) => (
              <Grid item xs={12} key={item.id}  ref={el => feedRefs.current[item.id] = el}>
                <FeedCard item={item}  />
              </Grid>
            ))}
          </Grid>
          {loadingFeeds && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
              <FeedPostSkeleton />
            </Box>
          )}
          {!hasMore && feedsData?.length > 0 && (
            <Typography align="center" sx={{ my: 3, color: "text.secondary" }}>
              You've reached the end of the feed
            </Typography>
          )}
          <div ref={loaderRef} style={{ height: 1 }} />
        </>
      )}
    </>
  );
};

export default FeedScreen;
